import { IShopAdvisor, ITeamUser } from './team-profile-store-types';

/**
 * Converts a shop advisor to a team user
 *
 * @param shopAdvisor The shop advisor to convert
 * @returns The converted team user
 */
export const convertShopAdvisorToTeamUser = (
  shopAdvisor: IShopAdvisor & {
    userToTeamId: string;
    teamId: string;
  },
): ITeamUser => ({
  isAdmin: false,
  isLeader: false,
  startDate: '',
  endDate: null,
  ldapId: '',
  personId: '',
  isMultiShop: false,
  email: '',
  username: '',
  address: '',
  address2: null,
  city: '',
  state: '',
  postalCode: '',
  country: null,
  bio: '',
  testimonials: [],
  status: '',
  stateLicenses: [],
  phoneNumbers: [],
  personalEmails: [],
  websiteLinks: [],
  title: '',
  evTitle: '',
  socialLinks: [],
  alternativeEmail: '',
  shopId: '',
  firstName: '',
  lastName: '',
  profileThumbnail: '',
  profilePicture: '',
  languages: [],
  designations: [],
  phoneNumber: '',
  preferredContactMethod: null,
  ...shopAdvisor,
});
